import isModal from './isModal';
import Cookies from 'cookies-js';
import parseQuerystring from '../../parseQuerystring';

export default function setPurlCookies() {
  const params = parseQuerystring(location.search);
  const { purl, purl_only } = params;
  if (isModal() && purl) {
    Cookies.set('purl', purl, {
      path: '/'
    });
    Cookies.set('purl_only', purl_only === "1" ? "1" : "0", {
      path: '/'
    });
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/setPurlCookies.js
 **/